import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Card, CardHeader, CardTitle, CardContent } from '../components/ui/Card'
import { Button } from '../components/ui/Button'
import { ArrowLeft } from 'lucide-react'
import { supabase } from '../lib/supabaseClient'

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [error, setError] = useState<string>()
  const [message, setMessage] = useState<string>()
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(undefined)
    setMessage(undefined)
    setLoading(true)

    try {
      const { error: resetError } = await supabase.auth.resetPasswordForEmail(email, {
  redirectTo: `${window.location.origin}/reset-password?email=${encodeURIComponent(email)}`,
})
      
      if (resetError) {
        setError(resetError.message)
      } else {
        setMessage('Check your email for password reset instructions')
      }
    } catch (err) {
      console.error('Password reset error:', err)
      setError('An unexpected error occurred')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-4 relative overflow-hidden">
      {/* Atmospheric lighting effects */}
      <div className="absolute top-0 right-0 w-[800px] h-[800px] rounded-full bg-primary-500/15 blur-[120px] -z-10"></div>
      <div className="absolute bottom-0 left-0 w-[800px] h-[800px] rounded-full bg-gray-300/20 blur-[120px] -z-10"></div>
      
      <div className="w-full max-w-md mb-6 relative z-10">
        <Button 
          as={Link} 
          to="/login" 
          variant="ghost" 
          className="flex items-center text-gray-700 hover:text-gray-950 transition-colors"
        >
          <ArrowLeft size={18} className="mr-1" />
          Back to Login
        </Button>
      </div>

      <Card className="w-full max-w-md glass-card shadow-lg z-10">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl font-display font-bold text-gray-950">
            Forgot Your <span className="gradient-text">Password</span>?
          </CardTitle>
        </CardHeader>

        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Email</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                className="mt-1 w-full p-3 border border-gray-300/50 rounded-lg bg-white/50 backdrop-blur-sm"
                required
              />
            </div>
            
            {error && <p className="text-red-600 text-sm">{error}</p>}
            {message && <p className="text-green-600 text-sm">{message}</p>}
            
            <Button 
              type="submit"
              disabled={!email || loading} 
              fullWidth
              className="bg-black hover:bg-gray-900 text-white font-medium !rounded-full shadow-md hover:shadow-lg transition-all duration-300"
            >
              {loading ? 'Sending...' : 'Send Reset Email'}
            </Button>
            
            <div className="text-center text-sm text-gray-700 mt-4">
              Remembered your password?{' '}
              <Link to="/login" className="text-primary-700 hover:text-primary-600 transition-colors hover:underline">
                Log in
              </Link>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  )
}